module.exports = __webpack_public_path__ + "34bc775d/img/comments-icon.fdec7fdb.svg";